export default __webpack_public_path__ + "static/media/relative-book-pro.01c85ca5.woff";